<div class="dialog-header-container">
  <h2 class="pd-t-5px" mat-dialog-title>{{meetingInfoData.meetingTitle}}</h2>
  <div>
    <button mat-icon-button mat-dialog-close aria-label="Example icon-button with heart icon">
        <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-divider class = "mat-divider"></mat-divider>
<div class="noTask" *ngIf="showContent == true">No task available in this meeting</div>
<mat-dialog-content class="dialog-without-actions p-4">
  <cdk-accordion class="example-accordion" multi = "true">
    <cdk-accordion-item
      expanded = "true"
      *ngFor="let item of meetingInfoData.agendaList; let index = index;" 
      #accordionItem="cdkAccordionItem"
      class="example-accordion-item"
      role="button"
      tabindex="0"
      [attr.id]="'accordion-header-' + index"
      [attr.aria-expanded]="accordionItem.expanded"
      [attr.aria-controls]="'accordion-body-' + index"
      >
      <div *ngIf="isTaskExist(item)" class="example-accordion-item-header d-flex align-items-center" (click)="accordionItem.toggle()">
      
        <button mat-icon-button class="example-accordion-item-description">
            <mat-icon [ngStyle]="{'margin-left':'-25px', 'margin-top':'5px'}">{{ accordionItem.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
        </button>
        <div [ngStyle]="{'margin-left':'-17px', 'margin-top':'3px'}">
            <h3 class="margin-0 f-weight"><div [innerHTML]="item.agendaTitle"></div></h3>
        </div>
      
      </div>
      <div
        class="example-accordion-item-body"
        role="region"
        [style.display]="accordionItem.expanded ? '' : 'none'"
        *ngIf="isTaskExist(item)"
        >
        <!-- <ng-container *ngFor="let agendaItems of item.minutesList;let minIndex = index;"> -->
          <!-- Note starts -->
          <table mat-table [dataSource] = "dataSource" class="col-12 mat-elevation-z2 demo-table">
            <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->
            <!-- Position Column -->
            <ng-container matColumnDef="taskTitle" >
              <th mat-header-cell *matHeaderCellDef class="col-3 header-container"> Task </th>
              <td mat-cell *matCellDef="let element"><div class="mtb-5 wrap task-title-editor-wrapper">
                <app-adc-editor
                            class="task-adc-editor"
                            [readOnly]="true"
                            [content]="element.taskTitle || ''"
                            [config]="readOnlyQuillConfig"
                          ></app-adc-editor>
              </div></td>
            </ng-container>
          
            <!-- Name Column -->
            <ng-container matColumnDef="createdByName">
              <th mat-header-cell *matHeaderCellDef class="col-3 header-container"> Assigned By </th>
              <td mat-cell *matCellDef="let element" class="mtb-5">  {{element.createdByName}} </td>
            </ng-container>
          
            <!-- Weight Column -->
            <ng-container matColumnDef="assignedTo">
              <th mat-header-cell *matHeaderCellDef class="col-3 header-container"> Assigned To </th>
              <td mat-cell class="mtb-5" *matCellDef="let element; let i = index">
                {{element.assignedTo}}
              </td>
            </ng-container>
          
            <!-- Symbol Column -->
            <ng-container matColumnDef="dueDateStr">
              <th mat-header-cell *matHeaderCellDef class="col-2 header-container"> Due Date </th>
              <td mat-cell *matCellDef="let element" class="mtb-5"> {{element.dueDateStr}} </td>
            </ng-container>
          
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef class="col-1 header-container"> Status </th>
              <td mat-cell *matCellDef="let element" class="mtb-5"> {{element.status}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" [hidden]="row.agendaId!==item.agendaId"></tr>
          </table>
          <!-- Task Ends -->
         
      <!-- </ng-container> -->
        <div *ngIf = "item.minutesList.length == 0">
            <h3 class="margin-0" [ngStyle]="{'margin-left':'45px !important'}"></h3>
        </div>
      </div>
    </cdk-accordion-item>
  </cdk-accordion>
</mat-dialog-content>